@if (left || right) {
    <div
        [attr.id]="id ? (id + '_wrapper') : null"
        class="agpr-actionBar"
        role="group"
        [attr.aria-label]="'Common.layout.actionBar' | localize"
    >
        <ng-container *ngTemplateOutlet="top"></ng-container>

        <div
            [attr.id]="id ? (id + '_row') : null"
            class="agpr-actionBar-row"
            [ngClass]="{'agpr-actionBar--rightSidebar': context === contexts.rightSidebar}"
        >
            @if (headingContext) {
                <span
                    class="u-srOnly"
                    role="heading"
                    [attr.aria-level]="headingLevel"
                >
                    {{ 'footerActions' | localize: {context: headingContext} }}
                </span>
            }

            <div
                [attr.id]="id ? (id + '_left') : null"
                class="agpr-actionBar-left"
            >
                <ng-container *ngTemplateOutlet="left"></ng-container>
            </div>
            <div
                [attr.id]="id ? (id + '_right') : null"
                class="agpr-actionBar-right"
            >
                <ng-container *ngTemplateOutlet="right"></ng-container>
            </div>
        </div>
    </div>
}
